/**
 * Tema do Módulo Resgate.
 *
 * É um objeto de OPÇÕES, não um tema pronto: o `<Layout>` do react-admin 3 chama
 * `createMuiTheme(theme)` internamente (ra-ui-materialui/lib/layout/Layout.js:188).
 * Passar um tema já criado aqui quebraria a mesclagem.
 *
 * Paleta espelha a identidade do pontuax-admin (`src/theme/index.js` lá).
 * As duas últimas chaves (`overrides.MuiFilledInput` e `sidebar`) repetem o que o
 * defaultTheme do react-admin trazia — substituir o tema inteiro descarta os dois.
 */

export const PONTUAX = {
  green: '#79CF62',
  greenLight: '#EAF7E6',
  greenDark: '#275030',
  ink: '#1B3D14',
  danger: '#C93333',
  surface: '#FFFFFF',
  canvas: '#F5F7F5',
  line: '#E0E0E3',
  muted: '#6B7B68',
};

const theme = {
  palette: {
    primary: {
      light: '#A8E39A',
      main: PONTUAX.green,
      dark: PONTUAX.greenDark,
      // Texto escuro sobre o verde da marca: branco sobre #79CF62 dá 1.9:1 e
      // reprova em qualquer critério de contraste. Com o verde-tinta dá 6.3:1.
      contrastText: PONTUAX.ink,
    },
    secondary: {
      light: '#A8E39A',
      main: PONTUAX.green,
      dark: PONTUAX.greenDark,
      contrastText: PONTUAX.ink,
    },
    error: {
      main: PONTUAX.danger,
      contrastText: '#FFFFFF',
    },
    background: {
      default: PONTUAX.canvas,
      paper: PONTUAX.surface,
    },
    text: {
      primary: '#1F2A1C',
      secondary: PONTUAX.muted,
    },
  },

  shape: {
    borderRadius: 8,
  },

  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h5: { fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { color: PONTUAX.muted },
  },

  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        minHeight: 40,
      },
      contained: {
        boxShadow: 'none',
        '&:hover': { boxShadow: 'none' },
        '&:active': { boxShadow: 'none' },
      },
    },
    MuiPaper: {
      rounded: { borderRadius: 12 },
    },
    MuiCard: {
      root: {
        border: `1px solid ${PONTUAX.line}`,
        borderRadius: 12,
        boxShadow: 'none',
      },
    },
    MuiChip: {
      root: { fontWeight: 600 },
    },
    MuiTableCell: {
      head: {
        backgroundColor: PONTUAX.canvas,
        fontWeight: 600,
        color: '#1F2A1C',
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        '&$disabled': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
      },
    },
  },

  sidebar: {
    width: 240,
    closedWidth: 55,
  },
};

export default theme;
